import React, { Component, Fragment } from 'react';
import axios from 'axios';

import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';

import withStyles from '@mui/styles/withStyles';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import { TextField } from '@mui/material';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';

import Loading from "../helper/Loading"
import { authContext } from "../../context/AuthContext";
import styles from "../styles";
import PageHeader from "../helper/PageHeader";

const titles = [
    {
        value: '1',
        label: 'Mr.',
    },
    {
        value: '2',
        label: 'Ms.',
    },
    {
        value: '3',
        label: 'Mrs.',
    },
    {
        value: '4',
        label: 'Dr.',
    },
];

const ethnicities = [
    {
        value: '',
        label: '',
    },
     {
        value: 'White',
        label: 'White',
    },
    {
        value: 'Black or African American',
        label:'Black or African American',
    },
    {
        value: 'Hispanic or Latino or Spanish Origin of any race',
        label: 'Hispanic or Latino or Spanish Origin of any race',
    },
    {
        value: 'Asian',
        label: 'Asian',
    },
    {
        value: 'American Indian or Alaskan Native',
        label: 'American Indian or Alaskan Native',
    },
    {
        value: 'Native Hawaiian or Other Pacific Islander',
        label: 'Native Hawaiian or Other Pacific Islander',
    },
    {
        value: 'Two or more races',
        label: 'Two or more races',
    },
];

const ageRanges = [
    {
        value: '',
        label:'',
    },
    {
        value: '17 or younger',
        label: '17 or younger',
    },
    {
        value: '18-25',
        label: '18-25',
    },
    {
        value: '26-35',
        label: '26-35',
    },
    {
        value: '36-45',
        label: '36-45',
    },
    {
        value: '46-60',
        label: '46-60',
    },
    {
        value: '61 or older',
        label: '61 or older',
    },
];

const Popup = props => {
    return (
        <div>
            <br />
            <Alert severity={props.severity} onClose={props.onClose}>{props.text}</Alert>
        </div>
    )
}

class UserAdmin extends Component {
    static contextType = authContext;

    constructor(props) {
        super(props);
        this.token = sessionStorage.getItem('accessToken');
        this.state = {
            loading: true,

            //isTrainee: this.props.isTrainee || sessionStorage.getItem('userTrack')==="S",
            //byAdmin: this.props.history.location.state && this.props.history.location.state.byAdmin || false,
            byAdmin: true,
            states: [],
            workCounties: [],
            homeCounties: [],
            error: null,
            modalMode: '',
            username: this.props.match.params.id || '',
            firstName: '',
            lastName: '',
            middleName: '',
            suffix: '',
            birthdate: '',
            title: '',
            email: '',
            alternateEmail: '',
            password: '',
            passwordCheck: '',
            homephone: '',
            workphone: '',
            homeLocID: null,
            homeAddress: '',
            homeCity: '',
            homeState: '', //auto
            homeCounty: '',
            homeZipcode: '',
            workLocID: null,
            employerName: '',
            workAddress: '',
            workCity: '',
            workState: '',
            workCounty: '',
            workZipcode: '',
            ethnicity: '',
            age: '',
            gender: null,
            jobTitle: '',
            companyEmployed: false,
            mailingAddressIsWorkLocation: false,

            isGatorLinkId: false,
            gatorlinkusername: null,

            note: '',

            updateSuccess: null,
            usernameChecked: false,
            tookGIBMPTraining : '',
            holdPesticideLicense : '',
            holdFertilizerLicense: '',
            fertilizerLicense: '',
            pesticideLicense:'',
        }
    }

    componentDidMount() {
        // on mount
        this.setStateOptions();

        this.refresh();

        ValidatorForm.addValidationRule('checkPasswords', (value) => {
            //console.log(this.state)
            if (value !== this.state.password) {
                return false;
            }
            return true;
        });
    }

    componentWillUnmount() {
        // on unmount
        if (ValidatorForm.hasValidationRule('checkPasswords'))
            ValidatorForm.removeValidationRule('checkPasswords');

        // fix Warning: Can't perform a React state update on an unmounted component
        this.setState = (state,callback)=>{
            return;
        };
    }


    setStateOptions = () => {
        axios('/api/stateCounty/states', {
            method: 'GET'
        }).then(res => {
            let states = [];
            res.data.states.map((u) =>
                states.push({ label: u, value: u })
            );
            console.log("SET STATE OPTIONS")
            this.setState({
                states,
            })
        }).catch(error => {
            this.setError(error)
        });
    }

    refresh = async () => {
        if (this.props.match.params.id !== undefined) {
            this.setState({ modalMode: 'Update' })

            try{
            const res = await axios.get('/api/user/' + this.props.match.params.id)
                const result = res.data
                console.log("Res",result.user)

                // grab initial fields from res
                let data = {
                    username: result.user.username, //username will be the same as props.id
                    firstName: result.user.first_name,
                    title: result.user.title,
                    lastName: result.user.last_name,
                    middleName: result.user.middle_name,
                    suffix: result.user.suffix===null ? '' : result.user.suffix,
                    credit: result.user.credit,
                    email: result.user.email,
                    birthdate: result.birthdate,
                    alternateEmail: result.userExt.secondaryEMAIL,
                    trainingID: result.userExt.TRAINEEID,
                    pesticideLicense: result.userExt.PESTICIDELICENSENUMBER,
                    fertilizerLicense: result.userExt.FERTILIZERLICENSENUMBER,
                    tookGIBMPTraining: result.userExt.TOOKGIBMPTRAINING,
                    holdPesticideLicense: result.userExt.HOLDPESTICIDELICENSE,
                    holdFertilizerLicense: result.userExt.HOLDFERTILIZERLICENSE,
                    gender: result.userExt.GENDER,
                    homephone: result.userExt.HOMEPHONE,
                    workphone: result.userExt.WORKPHONE,
                    ethnicity: result.userExt.ETHNICITY,
                    age: result.userExt.AGE,
                    jobTitle: result.userExt.JOBTITLE,
                    companyEmployed: result.userExt.companyEmployed,
                    mailingAddressIsWorkLocation: result.userExt.mailingAddressIsWorkLocation,
                    homeLocID: result.userExt.homeLocationId,
                    workLocID: result.userExt.workLocationId,
                    isGatorLinkId: result.user.isGatorLinkId,
                    gatorlinkusername: result.userExt.gatorlinkusername
                }
                //console.log("SETTING FORM DATA", data)

                // if the homLoc is defined, then get the address and city fields from that part of the res
                if (result.homeLoc) {
                    data = {
                        ...data,
                        homeAddress: result.homeLoc.STREET,
                        homeCity: result.homeLoc.CITY,
                        homeState:  result.homeLoc.STATECODE ,
                        homeCounty: result.homeLoc.COUNTYCODE ,
                        homeCounties: await this.getCounties(result.homeLoc.STATECODE),
                        homeZipcode: result.homeLoc.ZIPCODE
                    };
                    //console.log("SETTING FORM DATA AGAIN (homeLoc)", data)
                }

                // same as above but for workLoc
                if (result.workLoc) {
                    data = {
                        ...data,
                        employerName: result.workLoc.NAME,
                        workAddress: result.workLoc.STREET,
                        workCity: result.workLoc.CITY,
                        workState:result.workLoc.STATECODE ,
                        workCounty:  result.workLoc.COUNTYCODE ,
                        workCounties: await this.getCounties(result.workLoc.STATECODE),
                        workZipcode: result.workLoc.ZIPCODE
                    };
                    //console.log("SETTING FORM DATA AGAIN (workLoc)", data)
                }
                console.log("data: ", data)

                // sets form state based on data
                this.setState(data)
                this.setState({
                    loading: false
                })
           
            } catch(error) {
                    this.setError(error)

            };
        } else {
            this.setState({ modalMode: 'Create', loading: false })
            
        }
    }

    hideError = () => {
        this.setError('')
    }

    setError = (error) => {
        console.log("ERROR", error);
        console.log("ERROR MESSAGE", error.message)
        this.setState({ error: error.message })
    }

    handleChange = event => {
        this.setState({
            [event.target.name]: event.target.value
        });
    }

    handleSelectChange =  async (event) => {
        if (event.target.name === 'homeState' && event.target.name !== null) {
            let selectedHomeState = event.target.value;
            let county = await this.getCounties(selectedHomeState)
       
            this.setState({
                homeCounties: county,
                homeCounty: ''
            })
           
        } else if (event.target.name === 'workState' && event.target.name !== null) {
            let selectedHomeState = event.target.value;
            let county = await this.getCounties(selectedHomeState)
          
            this.setState({
                workCounties: county,
                workCounty: ''
            })
           
        }
        this.setState({ [event.target.name]: event.target.value });
    }
    handleCheckChange = event => {
        // console.log("event:" + event.target.name + " value:" + event.target.checked);

        this.setState({
            [event.target.name]: event.target.checked
        });
    }


    handleOptionChange = event => {
        // console.log("event:" + event.target.name + "id:" + event.target.id + " checked:" + event.target.checked);
        if (event.target.value === 'useWork' || event.target.value === 'yes' ) {
            this.setState({ [event.target.name]: true });
        } else {
            this.setState({ [event.target.name]: false });
        }
    }

    handleGenderChange = event => {
        if (event.target.value === 'isMale') {
            this.setState({ [event.target.name]: 1 });
        } 
        if (event.target.value === 'isFemale') {
            this.setState({ [event.target.name]: 2 });
        } 
        if (event.target.value === 'isOther') {
            this.setState({ [event.target.name]: 0 });
        }
    }

    getCounties = async state => {
        if(state===null || state=== '') return []
        const res = await axios.get('/api/stateCounty/county/' + state)
        const counties =  res.data.map(county => ({ label: county.stateCountyName, value: county.stateCountyName }))
        return counties
    }

    onUpdate = (event) => {
        let url = "/api/user/admin/" + this.props.match.params.id;
        console.log("On Update " + this.context.user.username);
        console.log(JSON.stringify({ ...this.state, 
            username: this.props.match.params.id,
            byUser: this.context.user.username
        }))
        axios(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': this.token
            },
            data: JSON.stringify({ ...this.state, 
                username: this.props.match.params.id,
                byUsername: this.context.user.username
            })
        }).then(response => {
            // console.log("response: " + response);
            if (response.status >= 400) {
                throw new Error(response.statusText);
            }

            //  ADD A VISUAL INDICATOR OF AN UPDATE HERE
            this.setState({ updateSuccess: true })

            this.refresh();
        }).catch(error => {
            this.setError(error)
            this.setState({ updateSuccess: false })
        });
    }

    onResetPassword = (event) => {
        this.props.history.push({
            pathname: '/resetPassword/' + this.props.match.params.id
        });
    }

    handleNeedTest = event => {
        if (event.target.value === 'Yes') {
            
           this.setState({tookGIBMPTraining: true})
        } else {
            this.setState({tookGIBMPTraining: false})
        }
    }

    handleNeedTestPL = event => {
        if (event.target.value === 'Yes') {
            
           this.setState({holdPesticideLicense: true})
        } else {
            this.setState({holdPesticideLicense: false})
        }
    }

    handleNeedTestFL = event => {
        if (event.target.value === 'Yes') {
            
           this.setState({holdFertilizerLicense: true})
        } else {
            this.setState({holdFertilizerLicense: false})
        }
    }
    
    renderTrainee = (classes) => {
        return (
            <Fragment>
                <div>
                    <Box pb={3} mt={4} mb={4} borderBottom={1} borderColor="#E0E0E0">
                        <h3 className="page-heading">Trainee Information</h3>
                    </Box>
                </div>


                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <FormLabel component="legend">Mailing address for training certificate</FormLabel>
                        <RadioGroup row aria-label="address" name="address" onChange={this.handleOptionChange}>
                            <FormControlLabel
                                id="useWork"
                                value="useWork"
                                checked={this.state.mailingAddressIsWorkLocation}
                                control={<Radio color="primary" />}
                                label="Work Address"
                                name="mailingAddressIsWorkLocation"
                            />
                            <FormControlLabel
                                id="useHome"
                                value="useHome"
                                checked={!this.state.mailingAddressIsWorkLocation}
                                control={<Radio color="primary" />}
                                label="Home Address"
                                name="mailingAddressIsWorkLocation"
                            />
                        </RadioGroup>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                                <FormLabel component="legend"
                                
                                >
                                     Have you taken GI-BMP training before?  
                                     </FormLabel>
                                <RadioGroup row aria-label="open" name="open" onChange={this.handleNeedTest} >
                                    <FormControlLabel
                                        id="isInPerson"
                                        value="Yes"
                                        checked={ this.state.tookGIBMPTraining===null? '' : this.state.tookGIBMPTraining }
                                        control={<Radio  color="primary" />}
                                        label="Yes"
                                        name="isGIBMPTrainee"
                                    />
                                    <FormControlLabel
                                        id="isRemote"
                                        value="No"
                                        checked={ this.state.tookGIBMPTraining===null? '' : !this.state.tookGIBMPTraining }
                                        control={<Radio  color="primary" />}
                                        label="No"
                                        name="isGIBMPTrainee"
                                    />
                                </RadioGroup>
                                {
                                    this.state.tookGIBMPTraining === true
                                    ?
                                    <Grid>
                                        <TextValidator
                                            id="trainingID"
                                            label={'Training ID'}
                                            type="text" className={[classes.textField].join(' ')}
                                            onChange={this.handleChange}
                                            value={this.state.trainingID || ""}
                                            name='trainingID'
                                            fullWidth
                                        />
                                    </Grid>
                                    :
                                    <></>
                    }
                               
                    </Grid>


                   

                    <Grid item xs={12} sm={6} lg={4}>
                                <FormLabel component="legend"
                                
                                > Do you have a pesticide license? </FormLabel>
                                <RadioGroup row aria-label="open" name="open" onChange={this.handleNeedTestPL}>
                                    <FormControlLabel
                                        id="isInPerson"
                                        value="Yes"
                                        checked={ this.state.holdPesticideLicense===null ? '' : this.state.holdPesticideLicense }
                                        control={<Radio color="primary" />}
                                        label="Yes"
                                        name="isPesticideLicense"
                                    />
                                    <FormControlLabel
                                        id="isRemote"
                                        value="No"
                                        checked={ this.state.holdPesticideLicense===null ? '' : !this.state.holdPesticideLicense }
                                        control={<Radio color="primary"  />}
                                        label="No"
                                        name="isPesticideLicense"
                                    />
                                </RadioGroup> 
                                {
                                    this.state.holdPesticideLicense === true
                                    ?
                                    <Grid>
                                    <TextValidator
                                        id="pesticideLicense"
                                        label= { "Pesticide License" }
                                        type="text" className={[classes.textField].join(' ')}
                                        onChange={this.handleChange}
                                        value={this.state.pesticideLicense || ""}
                                        name='pesticideLicense'
                                        fullWidth
                                    />
                                </Grid>
                                :
                                <></>
                    }
                               
                    </Grid>

                   

                    <Grid item xs={12} sm={6} lg={4}>
                                <FormLabel component="legend"
                                
                                >Do you have a fertilizer applicator license? </FormLabel>
                                <RadioGroup row aria-label="open" name="open" onChange={this.handleNeedTestFL}>
                                    <FormControlLabel
                                        id="isInPerson"
                                        value="Yes"
                                        checked={ this.state.holdFertilizerLicense===null ? '' : this.state.holdFertilizerLicense }
                                        control={<Radio color="primary"  />}
                                        label="Yes"
                                        name="isFertiliserApplicator"
                                    />
                                    <FormControlLabel
                                        id="isRemote"
                                        value="No"
                                        checked={ this.state.holdFertilizerLicense===null ? '' : !this.state.holdFertilizerLicense }
                                        control={<Radio color="primary"  />}
                                        label="No"
                                        name="isFertiliserApplicator"
                                    />
                                </RadioGroup>
                                {
                        this.state.holdFertilizerLicense === true
                        ?
                        <Grid>
                        <TextValidator
                            id="fertilizerLicense"
                            label= {'Fertiliser License'}
                            type="text" className={[classes.textField].join(' ')}
                            onChange={this.handleChange}
                            value={this.state.fertilizerLicense || ""}
                            name='fertilizerLicense'
                            fullWidth
                        />
                    </Grid>
                    :
                    <></>
                    }
                               
                    </Grid>
                {/* <Grid item xs={12} sm={6} lg={3}>
                        <TextField
                            id="trainingID"
                            label="Training ID"
                            type="text" className={[classes.textField].join(' ')}
                            onChange={this.handleChange}
                            value={this.state.trainingID}
                            name='trainingID'
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                        <TextField
                            id="pesticideLicense"
                            label="Pesticide License #"
                            type="text" className={[classes.textField].join(' ')}
                            onChange={this.handleChange}
                            value={this.state.pesticideLicense}
                            name='pesticideLicense'
                            fullWidth
                        />
                    </Grid> */}
                    <Grid item xs={12}>
                        <TextField
                            id="homeAddress"
                            label="Home Address"
                            type="text"
                            className={[classes.textField].join(' ')}
                            onChange={this.handleChange}
                            value={this.state.homeAddress}
                            name='homeAddress'
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                        <TextField
                            id="homeCity"
                            label="City"
                            type="text"
                            className={[classes.textField].join(' ')}
                            onChange={this.handleChange}
                            value={this.state.homeCity}
                            name='homeCity'
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                         <TextField
                            id="homeState"
                            name="homeState"
                            className={[classes.textField].join(' ')}
                            value={this.state.homeState}
                            onChange={this.handleSelectChange}
                            select
                            fullWidth
                            required
                            label="State"
                        >
                            {this.state.states.map((option) => (
                                <MenuItem key={option.value} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                        <TextField
                            id="homeCounty"
                            name="homeCounty"
                            className={[classes.textField].join(' ')}
                            value={this.state.homeCounty}
                            disabled={!this.state.homeState}
                            onChange={this.handleSelectChange}
                            select
                            fullWidth
                            label="County"
                            required
                        >
                            {this.state.homeCounties.map((option) => (
                                <MenuItem key={option.value} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>

                    <Grid item xs={12} sm={6} lg={3}>
                        <TextField
                            id="homeZipcode"
                            label="Zipcode"
                            type="number"
                            className={[classes.textField].join(' ')}
                            onChange={this.handleChange}
                            value={this.state.homeZipcode}
                            name='homeZipcode'
                            fullWidth
                        />
                    </Grid>
                </Grid>

                <div>
                    <Box pb={3} mt={4} mb={4} borderBottom={1} borderColor="#E0E0E0">
                        <h3 className="page-heading">Work Information</h3>
                    </Box>
                </div>

                <Grid container spacing={3}>
                    <Grid item xs={12} sm={6}>
                        <TextValidator
                            id="jobTitle"
                            label="Job Title"
                            type="text" className={[classes.textField].join(' ')}
                            onChange={this.handleChange}
                            value={this.state.jobTitle}
                            name='jobTitle'
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12}  sm={6}>
                        <FormLabel component="legend">Do you work for a company/organization?</FormLabel>
                        <RadioGroup row aria-label="work" name="work" onChange={this.handleOptionChange}>
                            <FormControlLabel
                                id="yes"
                                value="yes"
                                checked={this.state.companyEmployed}
                                control={<Radio color="primary" />}
                                label="Yes"
                                name="companyEmployed"
                            />
                            <FormControlLabel
                                id="no"
                                value="no"
                                checked={!this.state.companyEmployed}
                                control={<Radio color="primary" />}
                                label="No"
                                name="companyEmployed"
                            />
                        </RadioGroup>
                    </Grid>
                </Grid>

                {this.state.companyEmployed &&
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={6}>
                            <TextValidator
                                id="employerName"
                                label="Company/Organization Name"
                                type="text" className={[classes.textField].join(' ')}
                                onChange={this.handleChange}
                                value={this.state.employerName}
                                name='employerName'
                                validators={['required']}
                                errorMessages={['employer name is required']}
                                fullWidth
                                required
                            />
                        </Grid>                        
                        <Grid item xs={12} sm={6}>
                            <TextValidator
                                id="workAddress"
                                label="Work Address"
                                type="text"
                                className={[classes.textField].join(' ')}
                                onChange={this.handleChange}
                                value={this.state.workAddress}
                                name='workAddress'
                                validators={['required']}
                                errorMessages={['Address is required']}
                                fullWidth
                                required
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} lg={3}>
                            <TextValidator
                                id="workCity"
                                label="City"
                                type="text"
                                className={[classes.textField].join(' ')}
                                onChange={this.handleChange}
                                value={this.state.workCity}
                                name='workCity'
                                validators={['required']}
                                errorMessages={['City is required']}
                                fullWidth
                                required
                            />
                        </Grid>

                        <Grid item xs={12} sm={6} lg={3}>
                            <TextField
                                id="workState"
                                name="workState"
                                className={[classes.textField].join(' ')}
                                value={this.state.workState}
                                onChange={this.handleSelectChange}
                                select
                                fullWidth
                                label="State"
                            >
                                {this.state.states.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={6} lg={3}>                       
                            <TextField
                                    id="workCounty"
                                    name="workCounty"
                                    className={[classes.textField].join(' ')}
                                    value={this.state.workCounty}
                                    disabled={!this.state.workState}
                                    onChange={this.handleSelectChange}
                                    select
                                    fullWidth
                                    label="County"
                                    required
                                >
                                    {this.state.workCounties.map((option) => (
                                        <MenuItem key={option.value} value={option.value}>
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                </TextField>
                        </Grid>

                       
                        <Grid item xs={12} sm={6} lg={3}>
                            <TextValidator
                                id="workZipcode"
                                label="Zipcode"
                                type="number"
                                className={[classes.textField].join(' ')}
                                onChange={this.handleChange}
                                value={this.state.workZipcode}
                                name='workZipcode'
                                validators={['required']}
                                errorMessages={['Zipcode is required']}
                                fullWidth
                                required
                            />
                        </Grid>
                    </Grid>
                }

                <div>
                    <Box pb={3} mt={4} mb={4} borderBottom={1} borderColor="#E0E0E0">
                        <h3 className="page-heading">Demographics</h3>
                    </Box>
                </div>

                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <FormLabel component="legend">Gender</FormLabel>
                        <RadioGroup row aria-label="genderLabel" name="gender" onChange={this.handleGenderChange}>
                            <FormControlLabel
                                id="isMale"
                                value="isMale"
                                checked={this.state.gender === 1 ? true : false}
                                control={<Radio color="primary" />}
                                label="Male"
                                name="gender"
                            />
                            <FormControlLabel
                                id="isFemale"
                                value="isFemale"
                                checked={this.state.gender ===2 ? true : false}
                                control={<Radio color="primary" />}
                                label="Female"
                                name="gender"
                            />
                            <FormControlLabel
                                id="isOther"
                                value="isOther"
                                checked={(this.state.gender === 0 || this.state.gender === null) ? true : false}
                                control={<Radio color="primary" />}
                                label= "Other/Prefer not to specify"
                                name="gender"
                            />
                        </RadioGroup>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            id="ethnicity"
                            name="ethnicity"
                            className={[classes.textField].join(' ')}
                            value={this.state.ethnicity ? this.state.ethnicity : ''}
                            onChange={this.handleSelectChange}
                            select
                            fullWidth
                            label="Race/Ethnicity"
                        >
                            {ethnicities.map((option) => (
                                <MenuItem key={option.value} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextField
                            id="age"
                            name="age"
                            className={[classes.textField].join(' ')}
                            value={this.state.age}
                            onChange={this.handleSelectChange}
                            select
                            fullWidth
                            label="Age"
                        >
                            {ageRanges.map((option) => (
                                <MenuItem key={option.value} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                </Grid>
            </Fragment>
        );
    }

    renderPassword = (classes) => {
        if (this.state.modalMode === 'Create') {
            return (
                <Fragment>
                    <Grid item xs={12} sm={6}>
                        <TextValidator
                            id="password"
                            label="Password"
                            type="password"
                            className={[classes.textField].join(' ')}
                            onChange={this.handleChange}
                            value={this.state.password}
                            name='password'
                            validators={['required']}
                            errorMessages={['Password is required']}
                            fullWidth
                            required
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextValidator
                            id="passwordCheck"
                            label="Confirm Password"
                            type="password"
                            className={[classes.textField].join(' ')}
                            onChange={this.handleChange}
                            value={this.state.passwordCheck}
                            name='passwordCheck'
                            validators={['checkPasswords', 'required']}
                            errorMessages={['Password and Confirm Password must match', 'Confirm Password is required']}
                            fullWidth
                            required
                        />
                    </Grid>
                </Fragment>
            );
        } else {
            return (
                <Grid item xs={12}>
                    <Button variant="contained" color="primary" className={[].join(' ')} onClick={this.onResetPassword}>Reset Password</Button>
                </Grid>
            );
        }
    }

    handleInvalid(errors){
        // this focuses on the first component with a validation error
        const focusElem = document.getElementsByName(errors[0].props.name)
        if(focusElem.length === 1)
            focusElem[0].focus()
        
        // it seems like if it finds an autocomplete, there is a div and then an input with the same name. .focus does not seem to work on the div's
        else
            focusElem[1].focus()
            
        // console.log(errors)
        // console.log(errors[0].props.name)

    }

    render() {

        const { classes } = this.props;

        if(this.state.loading) return <Loading />
        return (
            <Fragment>

                {this.state.updateSuccess === true && <Popup severity="success" text="Updated Successfully" onClose={() => this.setState({ updateSuccess: null })} />}
                {this.state.updateSuccess === false && <Popup severity="warning" text="An error occured when updating" onClose={() => this.setState({ updateSuccess: null })} />}
                <ValidatorForm
                    noValidate
                    onError={this.handleInvalid} //called on a validation error, used to focus the first element
                    onSubmit={this.state.modalMode === "Create" ? this.onAdd : this.onUpdate}
                >
                    <PageHeader
                        title={"User Profile"}
                        cancel={this.props.history.goBack}
                        actionButtons={[{ label:  "Update" }]}
                        errorDetails={{
                            feedback: this.state.error,
                            dismiss: this.hideError
                        }}
                    />

                    <div>
                        <Grid container spacing={3}> 
                            <Grid item xs={12}>
                                {/*<div>
                                    <Box pb={3} mt={4} mb={4} borderBottom={1} borderColor="#E0E0E0">
                                       <h3 className="page-heading">Admin Note</h3>
                                    </Box>
                                </div>
                                */}
                                <TextValidator 
                                id="standard-basic" 
                                label="Admin Note" 
                                type="text" 
                                className={[classes.textField].join(' ')} 
                                onChange={this.handleChange} 
                                value={this.state.note} 
                                name='note' multiline fullWidth maxRows={10} 
                                validators={['required']}
                                errorMessages={['Admin note is required']}
                                required/>
                            </Grid>                     
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    id="username"
                                    label="username"
                                    type="text"
                                    className={[classes.textField].join(' ')}
                                    value={this.state.username}
                                    name='username'
                                    fullWidth
                                    disabled
                                />
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <TextValidator
                                    id="date"
                                    label="Birthday"
                                    type="date"
                                    name='birthdate'
                                    value={this.state.birthdate}
                                    className={[classes.textField].join(' ')}
                                    onChange={this.handleChange}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    validators={['required']}
                                    errorMessages={['Birthday is required']}
                                    fullWidth
                                    required
                                />
                            </Grid>
                                <Grid item xs={6}>
                                    <FormLabel component="legend">Account Type:?</FormLabel>
                                    <RadioGroup row aria-label="accountType" name="accountType" onChange={this.handleOptionChange}>
                                        <FormControlLabel
                                            id="yes"
                                            value="yes"
                                            checked={this.state.isGatorLinkId}
                                            control={<Radio color="primary" />}
                                            label="Gatorlink"
                                            name="isGatorLinkId"
                                        />
                                        <FormControlLabel
                                            id="no"
                                            value="no"
                                            checked={!this.state.isGatorLinkId}
                                            control={<Radio color="primary" />}
                                            label="GI-BMP"
                                            name="isGatorLinkId"
                                        />
                                    </RadioGroup>
                                </Grid>
                                { this.state.isGatorLinkId &&
                                <Grid item xs={6} >
                                     <TextValidator id="gatorlinkusername"
                                        label="Gatorlink Username"
                                        type="text"
                                        className={[classes.textField].join(' ')}
                                        onChange={this.handleChange}
                                        value={this.state.gatorlinkusername}
                                        name='gatorlinkusername'
                                        validators={['required']}
                                        errorMessages={['Gatorlink username is required']}
                                        fullWidth
                                        required
                                    />
                                </Grid>
                                }
                                


                            {!this.state.isGatorLinkId ? this.renderPassword(classes) : null}

                            <Grid item xs={12} sm={1}>
                                <TextField
                                    id="title"
                                    name="title"
                                    style={{ minWidth: '5ch' }}
                                    className={[classes.textField].join(' ')}
                                    value={this.state.title ? this.state.title : ''}
                                    onChange={this.handleSelectChange}
                                    select
                                    fullWidth
                                    label="Title"
                                >
                                    {titles.map((option) => (
                                        <MenuItem key={option.value} value={option.value}>
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={5}>
                                <TextValidator id="firstName"
                                    label="First Name"
                                    type="text"
                                    className={[classes.textField].join(' ')}
                                    onChange={this.handleChange}
                                    value={this.state.firstName}
                                    name='firstName'
                                    validators={['required']}
                                    errorMessages={['First name is required']}
                                    fullWidth
                                    required
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField id="middleName"
                                    label="Middle Name"
                                    type="text"
                                    className={[classes.textField].join(' ')}
                                    onChange={this.handleChange}
                                    value={this.state.middleName}
                                    name='middleName'
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextValidator id="lastName"
                                    label="Last Name"
                                    type="text"
                                    className={[classes.textField].join(' ')}
                                    onChange={this.handleChange}
                                    value={this.state.lastName}
                                    name='lastName'
                                    validators={['required']}
                                    errorMessages={['Last name is required']}
                                    fullWidth
                                    required
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    id="suffix"
                                    label="Suffix"
                                    type="text"
                                    className={[classes.textField].join(' ')}
                                    onChange={this.handleChange}
                                    value={this.state.suffix}
                                    name='suffix'
                                    fullWidth
                                />
                            </Grid>

                            {this.state.modalMode === 'Create' ? this.renderPassword(classes) : <span></span>}

                            <Grid item xs={12} sm={6} lg={3}>
                                <TextValidator
                                    id="email"
                                    label="Email"
                                    type="email"
                                    className={[classes.textField].join(' ')}
                                    placeholder='example@domain.com'
                                    onChange={this.handleChange}
                                    value={this.state.email}
                                    name='email'
                                    validators={['required', 'isEmail']}
                                    errorMessages={['Email is required', 'Please enter a valid email address']}
                                    fullWidth
                                    required
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} lg={3}>
                                <TextValidator
                                    id="alternateEmail"
                                    label="Alternate Email"
                                    type="email"
                                    className={[classes.textField].join(' ')}
                                    placeholder='example@domain.com'
                                    onChange={this.handleChange}
                                    value={this.state.alternateEmail}
                                    name='alternateEmail'
                                    validators={['isEmail']}
                                    errorMessages={['Please enter a valid email address']}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} lg={3}>
                                <TextValidator
                                    id="workphone"
                                    label="Work Phone"
                                    type="tel"
                                    className={[classes.textField].join(' ')}
                                    placeholder='987-654-3210 x1234'
                                    onChange={this.handleChange}
                                    value={this.state.workphone}
                                    name='workphone'
                                    validators={['required', 'matchRegexp:^([(]?\\d{3}[)]?\\s?-?\\d{3}-?\\d{4})(\\sx\\d{1,5})?$']}
                                    errorMessages={['Phone is required', 'Only "(", ")", "-", "x", and numbers are allowed. Must be at least 10 digits']}
                                    fullWidth
                                    required
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} lg={3}>
                                <TextValidator
                                    id="homePhone"
                                    label="Home Phone"
                                    type="tel"
                                    className={[classes.textField].join(' ')}
                                    placeholder='987-654-3210 x1234'
                                    onChange={this.handleChange}
                                    value={this.state.homephone}
                                    name='homephone'
                                    validators={['matchRegexp:^([(]?\\d{3}[)]?\\s?-?\\d{3}-?\\d{4})(\\sx\\d{1,5})?$']}
                                    errorMessages={['Only "(", ")", "-", "x", and numbers are allowed. Must be at least 10 digits']}
                                    fullWidth
                                />
                            </Grid>
                        </Grid>

                        {/*this.state.isTrainee === true && */
                            this.renderTrainee(classes)
                        }

                       

                    </div>
                </ValidatorForm >
            </Fragment>

        );
    }
}
export default withStyles(styles, { withTheme: true })(UserAdmin);

